import React from "react";
import BarTitle from "../../components/BarTitle";
import "./AdminPage.css";
import { Link } from "react-router";

const AdminPage = () => {
  return (
    <div>
      <BarTitle name="Administração" />
      <div className="admin-container">
        
        <Link to="/home/Admin/account"><button className="admin-button">Conta</button></Link>
        <button className="admin-button-disabled">Autenticação e Autorização</button>
        <button className="admin-button-disabled">Estabelecimentos</button>
        <button className="admin-button-disabled">Financeiro</button>
        <button className="admin-button-disabled">Geolocalização</button>
        <button className="admin-button-disabled">Notificações</button>
        <button className="admin-button-disabled">Serviços</button>
        <button className="admin-button-disabled">Taxas</button>
        <button className="admin-button-disabled">Logs de Atividade</button>
        <button className="admin-button-disabled">Configurações do Sistema</button>

      </div>
    </div>
  );
}

export default AdminPage;


// WEBPACK FOOTER //
// ./src/views/Admin/index.js